import { LoadingEnum } from "@perxis-auto/shared";
import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import * as internal_features_forms_actions from "./actions.js";
import { submitForm } from "./actions.js";
const formsAdapter = createEntityAdapter();
const initialState = {
  ...formsAdapter.getInitialState(),
  loading: LoadingEnum.Idle
};
const formsSlice = createSlice({
  name: "forms",
  initialState,
  reducers: {
    reset: () => initialState,
    setForm: formsAdapter.setOne,
    addForm: formsAdapter.addOne,
    updateForm: formsAdapter.updateOne,
    removeForm: formsAdapter.removeOne,
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setFormError(state, action) {
      formsAdapter.updateOne(state, {
        id: action.payload.formId,
        changes: {
          error: action.payload.error
        }
      });
    },
    setValues(state, action) {
      formsAdapter.updateOne(state, {
        id: action.payload.formId,
        changes: {
          fields: action.payload.fields
        }
      });
    },
    setErrors(state, action) {
      formsAdapter.updateOne(state, {
        id: action.payload.formId,
        changes: {
          fieldsErrors: action.payload.fieldsErrors
        }
      });
    },
    setValue(state, action) {
      var _a;
      formsAdapter.updateOne(state, {
        id: action.payload.formId,
        changes: {
          fields: {
            ...(_a = state.entities[action.payload.formId]) == null ? void 0 : _a.fields,
            [action.payload.id]: action.payload.value
          }
        }
      });
    }
  },
  extraReducers(builder) {
    builder.addCase(submitForm.pending, (state) => {
      state.loading = LoadingEnum.Pending;
    });
    builder.addCase(submitForm.fulfilled, (state, action) => {
      formsAdapter.updateOne(state, {
        id: action.payload.formId,
        changes: {
          result: action.payload.result
        }
      });
      state.loading = LoadingEnum.Succeeded;
    });
    builder.addCase(submitForm.rejected, (state, action) => {
      var _a, _b;
      if ((_b = (_a = action.payload) == null ? void 0 : _a.meta) == null ? void 0 : _b.formId) {
        formsAdapter.updateOne(state, {
          id: action.payload.meta.formId,
          changes: {
            error: action.payload
          }
        });
      }
      state.loading = LoadingEnum.Failed;
    });
  }
});
const formsActions = {
  ...formsSlice.actions,
  ...internal_features_forms_actions
};
export {
  formsActions,
  formsAdapter,
  formsSlice
};
